import styled from 'styled-components';

import { SelectPriority } from '@/features/vfo/components/SelectPriority';
import { Textarea } from '@/features/vfo/components/Textarea';
import { Input } from '@/features/vfo/uikit/Input';
import { Select } from '@/features/vfo/uikit/Select';
import { media } from '@/shared/components';
import { COLORS } from '@/shared/constants/colors';
import { DatePicker } from '@/shared/uikit/DatePicker';
import { DropdownMenu } from '@/shared/uikit/DropdownMenu';
import { Title } from '@/shared/uikit/Title';
import { Button } from '@/shared/uikitV2/Button';

export const Content = styled.div`
  display: flex;
  gap: 16px;
  height: 100%;

  ${media.sm} {
    flex-direction: column-reverse;
    gap: 24px;
    height: fit-content;
    overflow: auto;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  flex: 3 0 0;
  height: 100%;
  overflow-y: auto;
  padding-right: 16px;

  ${media.sm} {
    overflow-y: unset;
    padding-right: 0;
  }
`;

export const Text = styled.div`
  color: ${COLORS.systemDark200};
  white-space: pre-wrap;
  overflow: auto;
  max-height: 100%;
  flex-shrink: 0;

  &:hover {
    background: ${COLORS.systemLight200};
    cursor: pointer;
  }
`;

export const TitleStyled = styled(Title)`
  &:hover {
    background: ${COLORS.systemLight200};
    cursor: pointer;
  }

  ${media.sm} {
    margin-bottom: 16px !important;
  }
`;

export const InfoColumn = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  flex: 2 0 0;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 16px;

  ${media.sm} {
    gap: 8px;
    overflow-x: unset;
    overflow-y: unset;
    padding-right: 0;
  }
`;

export const Field = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;

  & > * {
    max-width: calc(100% - 90px - 24px);
  }
`;

export const Label = styled.div`
  width: 90px;
  color: ${COLORS.systemDark200};
`;

export const DatePickerStyled = styled(DatePicker)`
  &&& {
    padding: 0;
    height: auto;
    border: none;
    width: fit-content;
    box-shadow: none;

    ${media.sm} {
      min-width: 190px;
    }
  }
`;

export const SelectStyled = styled(Select)`
  &&& {
    height: auto;

    .ant-select-selector {
      padding: 0;
      border: none !important;
      width: 100%;
      box-shadow: none !important;

      &::after {
        line-height: normal;
      }
    }

    .ant-select-selection-placeholder,
    .ant-select-selection-item {
      line-height: normal;
    }

    &.caseSelect .ant-select-selection-item {
      color: ${COLORS.systemSky200};
    }
  }

  ${media.sm} {
    .ant-select-selection-item {
      max-width: calc(100% - 24px);
      overflow: hidden;

      * {
        text-overflow: ellipsis;
        overflow: hidden;
      }
    }
  }
`;

export const SelectPriorityStyled = styled(SelectPriority)`
  &&& {
    height: auto;

    .ant-select-selector {
      padding: 0 48px 0 0;
      border: none !important;
      width: fit-content;
      box-shadow: none !important;

      &::after {
        line-height: normal;
      }
    }

    .ant-select-selection-placeholder,
    .ant-select-selection-item {
      line-height: normal;
    }

    ${media.sm} {
      width: fit-content;
    }
  }
`;

export const DropdownMenuStyled = styled(DropdownMenu)`
  width: 100%;
  margin-bottom: -8px;

  ${media.sm} {
    margin-bottom: 0;
    width: fit-content;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  max-height: 100%;
  overflow: auto;
  min-height: 84px;
`;

export const InputStyled = styled(Input)`
  &&& {
    font-size: 18px;
    font-weight: 700;
    border: 2px solid ${COLORS.systemSky200};
    border-radius: 8px;
    height: 36px;
  }
`;

export const TextareaStyled = styled(Textarea)`
  &&& {
    border: 2px solid ${COLORS.systemSky200};
    border-radius: 8px;
  }
`;

export const DropdownWrapper = styled.div`
  width: 100%;

  ${media.sm} {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
`;

export const DeleteButton = styled(Button)`
  &&& {
    margin-top: auto;
    align-self: end;
    color: ${COLORS.systemFlame200};

    &:hover {
      color: ${COLORS.systemFlame300} !important;
    }
  }
`;

export const AttachmentsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const RowText = styled.p`
  font-weight: 700;
  line-height: 20px;
  display: flex;
  align-items: center;
  gap: 3px;
`;

export const TasksList = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FileWrapper = styled.button`
  padding-block: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  border: none;
  background: transparent;
  font-family: inherit;
  font-size: inherit;
`;

export const DocumentTitle = styled(Title)`
  margin-right: auto;
`;

export const Count = styled.span`
  color: ${COLORS.systemDark200};
`;

export const FileTypeWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${COLORS.systemDark200};
  border-radius: 4px;
  width: 28px;
  height: 36px;
  color: ${COLORS.white};
  position: relative;
  flex-shrink: 0;

  &.isExternal {
    background: ${COLORS.systemSky300};
  }
`;
